import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import { ROUTES } from '@shared-app/lib/constants';
import { useFile, useValidationUiStore } from '@entities/solution';
import { Layout } from '../../../layout';
import { ControlMenu } from './ControlMenu';
import { Result } from './Result';
const SELECTION_ORDER = ['wall', 'slab', 'scaffold'];
export function HierarchyPage() {
    const { id: fileId } = useParams();
    const navigate = useNavigate();
    const { data: file, isLoading } = useFile(fileId);
    const { selectedSolutionId, selectSolution, reset } = useValidationUiStore();
    // Reset selection whenever the file changes.
    useEffect(() => {
        reset();
    }, [fileId, reset]);
    // Select the first available solution when nothing is selected, or when the current
    // selection is no longer present (e.g. after the selected solution is deleted).
    useEffect(() => {
        var _a, _b;
        if (!file)
            return;
        const stillExists = SELECTION_ORDER.some(type => { var _a, _b; return (_b = (_a = file.solutions) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b.some(solution => solution.solutionID === selectedSolutionId); });
        if (selectedSolutionId && stillExists)
            return;
        for (const type of SELECTION_ORDER) {
            const first = (_b = (_a = file.solutions) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b[0];
            if (first) {
                selectSolution(first.solutionID, type);
                return;
            }
        }
        // No solutions remain.
        if (selectedSolutionId)
            selectSolution('', 'wall');
    }, [file, selectedSolutionId, selectSolution]);
    if (isLoading || !file) {
        return null;
    }
    const handleBreadcrumb = () => {
        navigate(ROUTES.VALIDATION.HIERARCHY.replace(':id', file.id));
    };
    return (_jsx(Layout, { title: "Validation", baseUrl: ROUTES.VALIDATION.INDEX, breadCrumProject: file.drawing_file_name, onBreadClick: handleBreadcrumb, children: _jsx(Stack, { width: '100%', children: _jsxs(Stack, { display: 'flex', flexDirection: 'row', width: '100%', children: [_jsx(ControlMenu, {}), _jsx(Result, {})] }) }) }));
}
